<template>
  <div class="section overflow-hidden position-relative" id="wrapper">

    <!-- Page Content Wrapper Start -->
      <div class="page-content-wrapper">
        <div class="container-fluid custom-container">
          <div class="admin-courses-tab-content">
            <h3 class="title">Final Test Records</h3><br />

            <div v-if='results.length'>
              <div class="tab-content" v-for='(result, index) in results' :key='result._id'>
                <div class="tab-pane fade show active" id="tab1">

                  <!-- Courses Item Start -->
                  <div class="courses-item padding-12 margin-12">
                    <div class="content-title">
                      <h3 class="title"><a href="#" class="margin-top-0">Final Test Attempt {{index+1}}</a></h3>
                    </div>
                    <div class="content-wrapper">
                      <div class="message-form margin-top-0">
                        <div class="message-input">
                          <div class="message-btn button-width margin-top-0">
                            <p class="btn btn-secondary font-weight-bold">Date Attempted: {{formatDate(result.test_attempt_date)}}</p>
                            <a @click='gotoRsults(result._id)' class="btn btn-primary btn-hover-dark ">View Test Result</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Courses Item End -->

                </div>

              </div>
            </div>
            <h2 v-else>
              This user hasn't attempted any test!
            </h2>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { fetchLatestTestResults } from '@/services/resultService';
export default{
  name: 'ManageResult',
  data(){
    return{
      user_id: null,
      results: []
    }
  },
  mounted(){
    this.user_id = this.$route.params.user_id;
    this.get_results();
  },
  methods:{
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
    },

    gotoRsults(id) {
      this.$router.push(`/dashboard/admin/result/${id}`);
    },
    async get_results(){
      this.results = await fetchLatestTestResults(this.user_id);
      console.log(this.results);
    }
  }
};
</script>